// src/contexts/WorkflowContext.js

import React, { createContext, useContext, useState } from 'react';

// Create the Workflow Context
const WorkflowContext = createContext();

// Create a Provider component
export const WorkflowProvider = ({ children }) => {
  const [savedAddress, setSavedAddress] = useState('');

  return (
    <WorkflowContext.Provider value={{ savedAddress, setSavedAddress }}>
      {children}
    </WorkflowContext.Provider>
  );
};

// Custom hook to use the WorkflowContext
export const useWorkflow = () => {
  return useContext(WorkflowContext);
};
